import {
  MODE_NONE,
  MODE_MOVE,
  MODE_RESIZE_BOTTOM,
  MODE_RESIZE_TOP,
  MODE_EDIT,
} from "./actions";
import { getItemByY, MIN_BLOCK, resolveItems } from "./utils";
import clamp from "lodash/clamp";
import { isSameDay } from "date-fns";
import { CalendarState, MouseMoveAction } from "./types";

export const mouseMoveReducer = (
  state: CalendarState,
  action: MouseMoveAction
): CalendarState => {
  switch (state.mode) {
    case MODE_NONE:
    case MODE_EDIT:
      const res = getItemByY(state, action.payload.date, action.payload.y);

      let cursor = state.cursor;

      if (res == null || res.mode === MODE_MOVE) {
        cursor = "default";
      } else if (res.mode === MODE_RESIZE_BOTTOM) {
        cursor = "s-resize";
      } else if (res.mode === MODE_RESIZE_TOP) {
        cursor = "n-resize";
      }

      if (state.cursor !== cursor) {
        return {
          ...state,
          cursor,
        };
      } else {
        return state;
      }

    case MODE_MOVE:
      const movingItem = state.items.find((x) => x.id === state.activeItem);
      const offsetMinute = clamp(
        Math.round((action.payload.y - state.offset.y) / state.rowHeight) *
          MIN_BLOCK +
          state.shownRange[0],
        state.shownRange[0],
        state.shownRange[1] - movingItem.length
      );

      if (
        isSameDay(movingItem.date, action.payload.date) &&
        movingItem.start === offsetMinute
      ) {
        return state;
      }

      return {
        ...state,
        algo: "overwrite",
        items: resolveItems(
          state.items,
          state.activeItem,
          action.payload.date,
          offsetMinute,
          null,
          false
        ),
      };

    case MODE_RESIZE_TOP:
      let resizingItem = state.items.find((x) => x.id === state.activeItem);
      const end = resizingItem.start + resizingItem.length;

      const minute = clamp(
        Math.round(action.payload.y / state.rowHeight) * MIN_BLOCK +
          state.shownRange[0],
        state.shownRange[0],
        end - MIN_BLOCK
      );

      if (resizingItem.start === minute) {
        return state;
      }

      return {
        ...state,
        algo: "overwrite",
        items: resolveItems(
          state.items,
          state.activeItem,
          null,
          minute,
          end - minute,
          false,
          "overwrite",
          state.shownRange[1]
        ),
      };

    case MODE_RESIZE_BOTTOM:
      const resizingBottomItem = state.items.find(
        (x) => x.id === state.activeItem
      );
      const length = clamp(
        Math.round(action.payload.y / state.rowHeight) * MIN_BLOCK +
          state.shownRange[0] -
          resizingBottomItem.start,
        MIN_BLOCK,
        state.shownRange[1] - resizingBottomItem.start
      );

      if (resizingBottomItem.length === length) {
        return state;
      }

      return {
        ...state,
        algo: action.altKey ? "move" : "overwrite",
        items: resolveItems(
          state.items,
          state.activeItem,
          null,
          null,
          length,
          false
        ),
      };

    default:
      throw new Error("Invalid mode");
  }
};
